import { Box, Typography } from "@mui/material";
import WarningAmberIcon from "@mui/icons-material/WarningAmber";
import Grid from '@mui/material/Grid2';
import { Link } from 'react-router-dom';

type SeverityOptions = "general" | "error";

interface BrowserCheckMessageProps {
  severity?: SeverityOptions;
  message: string;
  onLearnMoreClick?: () => void;
  customLinkLabel?: string;
  hideIcon?: boolean;
};

type SeverityStyles = {
  [K in SeverityOptions]: {
    backgroundColor: string,
  }
};

const severityStyles: SeverityStyles = {
  general: {
    backgroundColor: "#EDFBFF",
  },
  error: {
    backgroundColor: "#FDDBEF",
  }
};

const BrowserCheckMessage = ({
  severity="general",
  message,
  onLearnMoreClick = () => {},
  customLinkLabel = "Learn More",
  hideIcon = false,
}: BrowserCheckMessageProps) => {
  return (
    <>
      <Box sx={{
        height: "35px",
        backgroundColor: severityStyles[severity],
        width: "full",
        marginLeft: "8px",
        marginRight: "8px",
        marginBottom: "10px",
        display: "flex",
        justifyContent: "center",
        alignContent: "center",
      }}>
        <Grid container sx={{ alignItems: "center" }}>
          {
            hideIcon
              ? (<div className="w-[14px] h-[18px] mr-1" />)
              : (<WarningAmberIcon sx={{ width: "14px", height: "18px", color: "#181818", marginRight: "4px" }} />)
          }

          <Typography variant="body1" sx={{ color: "#181818", fontSize: "14px", paddingTop: "1px", marginRight: "4px" }} >{ message }</Typography>
          <Link to="" onClick={onLearnMoreClick} style={{ color: "#3776F0", fontSize: "14px", textDecoration: "none" }}>{ customLinkLabel }</Link>
        </Grid>
      </Box> 
    </>
  )
}

export default BrowserCheckMessage;
